import React, {ErrorInfo} from "react";
import * as Sentry from "@sentry/react";
import ThemeData from "../../Interfaces/ThemeData";
import {useAppSelector} from "../../store/hooks";

interface ErrorBoundaryProps {
    key?: string|null,
    place?: string|null
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps> {

    constructor(props:any) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error:Error, info:ErrorInfo) {
        this.setState({ hasError: true });

        Sentry.captureException(
            new Error('ErrorBoundary exception. ' + this.props.place),
            {
                extra: {
                    error: error,
                    info: info,
                    place: this.props.place,
                    props: JSON.stringify(this.props)
                }
            }
        );
    }

    render() {
        // @ts-ignore
        if (this.state.hasError) {
            return (
                <span className="error-boundary">
                    <i className="fa fa-circle-xmark"></i>
                    Произошла ошибка, попробуйте ещё раз
                </span>
            );
        }
        return this.props.children;
    }
}